<template>
  <div
    v-if="isCo"
    layout="column"
    style="width: 300px"
  >
    <v-toolbar flat>
      <v-list class="pt-1 pb-3">
        <v-list-tile>
          <v-list-tile-title class="title grey--text text-uppercase">{{$t('nav.messages')}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-list
      dense
      class="pt-0"
    >
      <!-- Mon Mur -->
      <v-list-tile
        @click="goWall"
        :class="{'active-tab' : $route.name.indexOf('my-wall') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">
            <div
              layout="row"
              layout-align="start center"
            >
              {{$t('nav.wall')}}
              <v-badge
                v-if="nbWall"
                color="red"
                overlap
                class="sidenav-badge"
              >
                <span slot="badge">{{nbWall}}</span>
              </v-badge>
            </div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- Mes messages -->
      <v-list-tile
        @click="goMessages"
        :class="{'active-tab' : $route.name.indexOf('my-messages') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">
            <div
              layout="row"
              layout-align="start center"
            >
              {{$t('nav.privates')}}
              <v-badge
                v-if="nbPrivate"
                color="red"
                overlap
                class="sidenav-badge"
              >
                <span slot="badge">{{nbPrivate}}</span>
              </v-badge>
            </div>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- Abusive Messages if Admin -->
      <v-list-tile
        v-if="isAdmin"
        @click="$router.push({name: 'abusive-messages-index'})"
        :class="{'active-tab' : $route.name.indexOf('abusive-messages') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">
            {{$t('nav.abusive')}}
            <v-badge
              v-if="nbReports"
              color="red"
              overlap
              class="sidenav-badge"
            >
              <span slot="badge">{{nbReports}}</span>
            </v-badge>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-toolbar
      flat
      id="all-circles-title"
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title
              layout="row"
              layout-align="start center"
              class="title full-width text-uppercase"
              flex
            ><span class="grey--text">{{$t('nav.circles')}}</span>
              <span flex />
              <a @click.prevent="$router.push({name: 'circles-edit', params: {id: 'new'}})">
                <v-icon class="plus-btn">mdi-plus</v-icon>
              </a>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <a
                href="#"
                @click.prevent="$router.push({name: 'circles-index'})"
              >{{$t('nav.the_circles')}}</a>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <!-- Circles -->
    <v-list
      dense
      class="pt-0"
    >
      <!-- My Circle -->
      <v-list-tile
        @click="goCircle"
        :class="{'active-tab' : $route.name.indexOf('my-circle') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">
            <div
              layout="row"
              layout-align="start center"
            >
              {{$t('nav.circle')}}
              <v-badge
                v-if="nbCircle"
                color="red"
                overlap
                class="sidenav-badge"
              >
                <span slot="badge">{{nbCircle}}</span>
              </v-badge>
            </div>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon>star</v-icon>
        </v-list-tile-action>
      </v-list-tile>

      <!-- list for the circles where user is subscribed -->
      <v-list-tile
        v-for="(c, index) in $store.state.circles"
        :key="c.id"
        @click="$router.push({name: 'circles-show', params: {id: c.id}})"
        :class="{'active-tab' : (($route.name.indexOf('circles-show') == 0) && ($route.params.id == c.id))}"
        @mouseover="$set(unsubscribeBtn, index, true)"
        @mouseleave="$set(unsubscribeBtn, index, false)"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{c.name}}
            <v-badge
              v-if="c.nb_unread"
              color="red"
              overlap
              class="sidenav-badge"
            >
              <span slot="badge">{{c.nb_unread}}</span>
            </v-badge>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action
          @click="leavingCircle = c.id; leaveDialog = true"
          v-show="unsubscribeBtn[index] || (($route.name.indexOf('circles-show') == 0) && ($route.params.id == c.id))"
          v-if="c.creator_id !== userId"
        >
          <v-icon :title="$t('nav.unsubscribe')">mdi-account-remove</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title grey--text text-uppercase">{{$t('nav.tools')}}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-list
      dense
      class="pt-0"
    >
      <v-list-tile
        v-if="isAdmin"
        @click="$router.push({name: 'admin-index'})"
        :class="{'active-tab' : $route.name.indexOf('admin-settings') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.settings')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="isAdmin"
        @click="$router.push({name: 'admin-schools-index'})"
        :class="{'active-tab' : $route.name.indexOf('admin-schools') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.schools')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        @click="$router.push({name: 'representatives-index'})"
        :class="{'active-tab' : $route.name.indexOf('representatives') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.book')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        @click="$router.push({name: 'documents-index'})"
        :class="{'active-tab' : $route.name.indexOf('documents-') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.docs')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="isAdmin || isNational"
        @click="$router.push({name: 'surveys-index'})"
        :class="{'active-tab' : $route.name.indexOf('surveys-') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.surveys')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if="isAdmin"
        @click="$router.push({name: 'admin-stats-connections'})"
        :class="{'active-tab' : $route.name.indexOf('admin-stats') == 0}"
      >
        <v-list-tile-content>
          <v-list-tile-title class="black--text subheading">{{$t('nav.stats')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-dialog
      v-model="leaveDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('nav.unsubscribe')}}</v-card-title>
        <v-card-text>
          {{$t("circles.unsubscribe_confirm")}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="leaveDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="leaveCircle"
          >
            {{$t('circles.leave')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Auth from "~/plugins/auth"
import Messages from "@/api/messages"
import Conversations from "@/api/conversations"
import Consts from "@/consts"
import EventBus from "@/plugins/eventbus"
import Circles from "@/api/circles"

export default {
  data () {
    return {
      isAdmin: false,
      isNational: false,
      nbCircle: 0,
      nbWall: 0,
      nbPrivate: 0,
      nbReports: 0,
      circleLoaded: false,
      wallLoaded: false,
      isCo: false,
      unsubscribeBtn: [],
      userId: "",
      leaveDialog: false,
      leavingCircle: null
    }
  },
  mounted () {
    this.loadUser()

    if (Auth.user) {
      this.fetchNbWall()
      this.fetchNbCircle()
      this.fetchNbPrivate()
      if (this.isAdmin) {
        this.fetchNbReports()
      }
    }

    this.interval = setInterval(
      function () {
        if (Auth.user) {
          this.fetchNbWall()
          this.fetchNbCircle()
          this.fetchNbReports()
        }
      }.bind(this),
      60000
    ) //Refresh le nb de messages non lus toutes les minutes

    this.intervalPrivates = setInterval(
      function () {
        if (Auth.user) {
          this.fetchNbPrivate()
        }
      }.bind(this),
      10000
    )

    EventBus.$on("user-changed2", this.loadUser)
    EventBus.$on("wall-fetch", this.fetchNbWall)
    EventBus.$on("circle-fetch", this.fetchNbCircle)
    EventBus.$on("abusive-updated", this.fetchNbReports)
    EventBus.$on("privates-update", this.fetchNbPrivate)
  },
  destroyed () {
    EventBus.$off("user-changed2")
    EventBus.$off("wall-fetch")
    EventBus.$off("circle-fetch")
    EventBus.$off("abusive-updated")
    EventBus.$off("privates-update")
    clearInterval(this.interval)
    clearInterval(this.intervalPrivates)
  },
  methods: {
    loadUser () {
      if (
        Auth.user &&
        (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY)
      ) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }

      if (Auth.user && Auth.user.level == Consts.NATIONAL) {
        this.isNational = true
      } else {
        this.isNational = false
      }

      if (Auth.authenticated && Auth.user) {
        this.isCo = true
        this.userId = Auth.user.id
      } else {
        this.isCo = false
      }
    },
    fetchNbCircle () {
      Messages.getUnread(1).then((res) => {
        if (
          this.circleLoaded &&
          res.data &&
          res.data != 0 &&
          res.data != this.nbCircle
        ) {
          EventBus.$emit("new-circle", res.data)
        }
        this.nbCircle = res.data
        this.circleLoaded = true
      })
    },
    fetchNbWall () {
      Messages.getUnread(0).then((res) => {
        if (
          this.wallLoaded &&
          res.data &&
          res.data != 0 &&
          res.data != this.nbWall
        ) {
          EventBus.$emit("new-wall", res.data)
        }
        this.nbWall = res.data
        this.wallLoaded = true
      })
    },
    fetchNbPrivate () {
      Conversations.getUnread().then((res) => {
        if (res.data && res.data != 0 && res.data != this.nbPrivate) {
          EventBus.$emit("new-private", res.data)
        }

        this.nbPrivate = res.data
      })
    },
    goWall () {
      if (this.$route.name != "my-wall") {
        this.nbWall = 0
      }
      this.$router.push({ name: "my-wall" })
    },
    goCircle () {
      if (this.$route.name != "my-circle") {
        this.nbCircle = 0
      }
      this.$router.push({ name: "my-circle" })
    },
    goMessages () {
      // On va pas remettre le compteur à 0 directement mais on va attendre l'event venant des PrivateMessages
      // if (this.$route.name != "my-messages") {
      //   this.nbPrivate = 0;
      // }
      this.$router.push({ name: "my-messages" })
    },
    fetchNbReports () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY) {
        Messages.nbReports().then((res) => {
          this.nbReports = res.data
        })
      }
    },
    leaveCircle () {
      Circles.leave(this.leavingCircle).then(() => {
        this.$snotify.success(this.$t("circles.left"))
        this.$store.commit("LOAD_CIRCLES", true)
        this.leaveDialog = false

        if (this.$route.name === 'circles-show' && this.$route.params.id === this.leavingCircle) {
          this.$router.push({ name: 'my-wall' })
        }

        this.leavingCircle = null
      })
    },
  },
};
</script>

<style scoped>
.active-tab {
  border-left: 4px solid #589c8f;
  background-color: #e8f8f7;
}

.unactive-tab {
  border-left: 4px solid transparent;
}

#all-circles-title {
  padding-bottom: 0 !important;
}
</style>
<style>
.plus-btn:hover {
  color: #2e3b7f;
}
.active-tab > .v-list__tile {
  font-weight: bold;
}
.sidenav-badge > .v-badge__badge {
  top: 0;
  right: 0;
  position: unset;
  margin-left: 5px;
}
.sidenav-badge {
  position: unset;
}
</style>